import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { EmptyFilter, OperatorFilter, TermFilter } from '@dofleini/query-builder';
import { transformWhitObjectId } from 'modules/common/constants/object-id';
import { STOCK_OPERATION } from 'modules/reports/components/common/constants/enums';
import WarehouseStockFilter from './WarehouseStockFilter';
import { STATUS } from 'modules/common/constants';
import { warehouseFilter } from './inventory-shared.filters';
import { USERS_TYPE_ENUM } from 'modules/inventory/provider/common/constants';
import { UserAdminService } from 'modules/security/users/services';
import { USERS_LIST_KEY } from 'modules/security/users/constants/queries';
import { orderFilter } from 'modules/sales/incidence-resolution/constants';

export const operationFilter: Filter = {
  filter: 'report:report.inventory.activity.operation',
  type: FilterType.FIXED_LIST,
  translate: true,
  key: 'operation',
  field: 'operation',
  transform: (value: string) => {
    if (!value || value === 'ALL') return undefined;

    return new TermFilter({ field: 'operation', value });
  },
  options: Object.keys(STOCK_OPERATION).map((key) => ({
    value: key,
    translate: true,
    label: `stock:operation.${key}`,
  })),
};
export const requiredCompensationFilter: Filter = {
  filter: 'stockReductionCause:fields.requiresSupplierCompensation',
  type: FilterType.FIXED_LIST,
  translate: true,
  key: 'reqComp',
  field: 'cause.requiresSupplierCompensation',
  options: Object.keys(STATUS).map((key) => ({
    value: STATUS[key],
    translate: true,
    label: `causesIncidence:notification.${key.toLocaleLowerCase()}`,
  })),
  transform: (value: any) => {
    if (Array.isArray(value)) return new EmptyFilter();
    switch (value) {
      case 'false':
        return new OperatorFilter({
          type: 'OR',
          filters: [
            new TermFilter({ field: 'cause.requiresSupplierCompensation', value: false }),
            new TermFilter({ field: 'cause.requiresSupplierCompensation', value: null }),
          ],
        }).toQuery();
      case 'true':
        return new TermFilter({ field: 'cause.requiresSupplierCompensation', value: true }).toQuery();
    }
  },
};

export const warehouseStockFilter: Filter = {
  filter: 'warehouse:name',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'warehouse',
  labelKey: 'warehouseName',
  field: 'warehouse',
  transform: (value) => transformWhitObjectId(value, 'warehouse'),
  Component: WarehouseStockFilter,
};

export const quantityFilter: Filter = {
  filter: 'report:report.inventory.activity.quantity',
  translate: true,
  type: FilterType.NUMBER,
  key: 'quantity',
  field: 'quantity',
};

export const compensationFilter: Filter = {
  filter: 'stock:fields.compensation',
  translate: true,
  type: FilterType.NUMBER,
  key: 'compensation',
  field: 'compensation',
};

export const createdATFilter: Filter = {
  filter: 'common:createdAt',
  translate: true,
  type: FilterType.DATE,
  key: 'createdAt',
  field: 'createdAt',
};

const responsibleTypeFilter: Filter = {
  filter: 'incidence:fields.responsibleType',
  translate: true,
  key: 'responsible',
  field: 'responsible.providerType',
  type: FilterType.FIXED_LIST,
  options: Object.keys(USERS_TYPE_ENUM)?.map((type) => ({
    value: type,
    translate: true,
    label: `common:provider.${type}`,
  })),
};

export const userFilter: Filter = {
  filter: 'common:username',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'user',
  labelKey: 'fullName',
  field: 'owner',
  fetchFunc: UserAdminService.search,
  fetchOption: { size: 200 },
  queryKey: USERS_LIST_KEY,
  transform: (value) => transformWhitObjectId(value, 'owner'),
};

export const reportProductInventoryFilters = [warehouseStockFilter, createdATFilter];

export const reportStockActivityFilters = [
  operationFilter,
  quantityFilter,
  userFilter,
  warehouseFilter,
  responsibleTypeFilter,
  compensationFilter,
  requiredCompensationFilter,
  orderFilter,
  createdATFilter,
];

export const defaultReportStockActivityFilters = [
  operationFilter,
  quantityFilter,
  userFilter,
  warehouseFilter,
  responsibleTypeFilter,
  compensationFilter,
  createdATFilter,
];
